namespace $.$$ {

	export class $shm_hitalama_app_overlay extends $.$shm_hitalama_app_overlay {

		hide_popover() {
			const overlay = this.dom_tree() as HTMLElement
			overlay.removeAttribute( 'popover' )
		}

		/** for place it above fullscreen popover */
		show_popover( force = false ) {
			const overlay = this.dom_tree() as HTMLElement
			if( force ) overlay.removeAttribute( 'popover' )
			if( overlay.popover !== 'manual' ) overlay.popover = 'manual'
			if( !overlay.matches( ':popover-open' ) ) overlay.showPopover()
		}

		overlayed_map_entity() {
			return this.$.$mol_error_fence(
				()=> $shm_hitalama_profile.current()?.overlayed_map() ?? null,
				()=> null,
				()=> null,
			)
		}

		overlayed_map_visible(): readonly $mol_view[] {
			const profile = this.$.$mol_error_fence(
				()=> $shm_hitalama_profile.current(),
				()=> null,
				()=> null,
			)
			if( !profile ) return []
			if( !profile.overlayed_map_enabled() ) return []

			const map = this.overlayed_map_entity()
			if( !map ) return []
			if( this.$.$mol_state_arg.value( 'settings' ) === 'overlayed_map' ) return []
			if( map.link().toString() === this.$.$mol_state_arg.value( 'map' ) ) return []

			return [ this.Overlayed_map() ]
		}

		fullscreen_close_uri() {
			const dict = this.$.$mol_state_arg.dict()
			return this.$.$mol_state_arg.link({ ...dict, fullscreen_widget: null })
		}

		fullscreen_panel(): readonly ( any )[] {
			return this.$.$mol_state_arg.value( 'fullscreen_widget' ) ? super.fullscreen_panel() : []
		}

	}

}
